import './App.css';
import Title from './components/title';
import About from './components/about';
import Mission from './components/mission';
import Why from './components/why';
import Services from './components/services';
import Gallery from './components/gallery';
import Contact from './components/contact';

function App() {
  return (
    <>
      <Title />
      <About />
      <div className="intro">
        <Mission />
        <Why />
      </div>
      <Services />
      <Gallery />
      <Contact />
    </>
  );
}

export default App;
